'use client';

import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import { Calendar } from '@/components/ui/calendar';
import { DateRange } from 'react-day-picker';
import { BookableDate } from '@prisma/client';

interface MobileCalendarProps {
  isOpen: boolean;
  onOpenChange: (_open: boolean) => void;
  date: DateRange | undefined;
  handleDateChange: (_range: DateRange | undefined, _selectedDay?: Date) => void;
  minStay: number | null;
  dateMatcher: (_day: Date) => boolean;
  bookableDates: BookableDate[];
  startMonth?: Date;
}

export function MobileCalendar({
  isOpen,
  onOpenChange,
  date,
  handleDateChange,
  minStay,
  dateMatcher,
  bookableDates,
  startMonth,
}: MobileCalendarProps) {
  return (
    <>
      <Button
        variant="outline"
        onClick={() => onOpenChange(true)}
        className="flex-col items-start w-full h-auto text-sm"
      >
        <span className="font-semibold uppercase text-[0.65rem]">CHECK IN - CHECK OUT</span>
        {date?.from && date?.to ? (
          <span className="font-normal">
            {date?.from ? date.from.toLocaleDateString() : ''} -{' '}
            {date?.to ? date.to.toLocaleDateString() : ''}
          </span>
        ) : (
          <span className="font-normal">Select dates</span>
        )}
      </Button>
      <Sheet open={isOpen} onOpenChange={onOpenChange}>
        <SheetContent side="bottom" className="h-[90vh] p-0 flex flex-col">
          <SheetHeader className="px-4 py-3 border-b">
            <SheetTitle>Select dates</SheetTitle>
          </SheetHeader>
          <div className="p-0 overflow-auto items-center flex justify-center">
            <Calendar
              mode="range"
              min={minStay || 1}
              required={true}
              excludeDisabled={true}
              disabled={dateMatcher}
              numberOfMonths={1}
              selected={date}
              bookableDates={bookableDates}
              startMonth={startMonth}
              onSelect={handleDateChange}
              onClose={() => onOpenChange(false)}
              className="rounded-none border-0"
              showOutsideDays={false}
            />
          </div>
          <div className="flex justify-end items-between flex-col gap-8 p-4">
            {date?.from && minStay && (
              <div className="text-sm">
                for the selected check in date{' '}
                <span className="font-semibold">{date?.from?.toLocaleDateString()} </span>
                there are {minStay} {minStay === 1 ? 'night' : 'nights'} minimum stay required
              </div>
            )}

            <div className="flex items-center gap-4">
              <p className="text-sm text-muted-foreground">Legend:</p>

              <div className="flex items-center">
                <p className="text-sm">Available Dates</p>
              </div>
              <div className="flex items-center">
                <p className="text-sm text-muted-foreground line-through">Unavailable Dates</p>
              </div>
            </div>
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
}
